import {
	type ReminderListResponseDTO,
	ReminderStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { mapReminderDto } from "web_myplann/Reminders/Mappers/mapReminderDto";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";

// The BE now receives the same filter/sort via query params (see
// remindersListParams.ts), but this client-side normalization is kept
// deliberately: mutation hooks write raw DTOs straight into the list caches
// (remindersCacheUtils.ts — resolved reminders keep their solvedAt, new
// reminders are appended), so `select` is what keeps the rendered list
// correct in between a mutation and the next refetch.
export const selectReminders = (data: ReminderListResponseDTO): Reminder[] =>
	(data?.reminders ?? [])
		.map(mapReminderDto)
		.filter((reminder) => reminder.status !== ReminderStatusEnum.Solved)
		.sort((a, b) => a.date.getTime() - b.date.getTime());
